webpackJsonp([62],{

/***/ 1227:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".footer-nav{padding:2em}.footer .nav-list:first-child .nav-item:first-child{border-top:none}.footer .nav-item{border:none;padding:.25em 0}.footer .nav-item-a{padding-right:1em;line-height:2}.footer .nav-item-a .fa{display:none}.footer .nav-sub-item{display:block;padding:.25em 0}.footer .nav-sub-item-a{padding-right:1em;line-height:2}.footer-info{padding:2em}.footer-copyright-p{text-align:right}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/footer/FooterCompany1/src/components/footer/FooterCompany1/FooterCompany1.m.scss"],"names":[],"mappings":"AAGE,YACE,WAAY,CACb,AAHH,oDAQU,eAAgB,CACjB,AATT,kBAaM,YAAY,AACZ,eAAgB,CAQjB,AAtBL,oBAgBQ,kBAAkB,AAClB,aAAc,CAIf,AArBP,wBAmBU,YAAa,CACd,AApBT,sBAyBQ,cAAc,AACd,eAAgB,CAKjB,AA/BP,wBA4BU,kBAAkB,AAClB,aAAc,CACf,AAIP,aACE,WAAY,CACb,AAEC,oBACE,gBAAiB,CAClB","file":"FooterCompany1.m.scss","sourcesContent":["@import '~scss/variables';\n\n.footer {\n  &-nav {\n    padding: 2em;\n  }\n  & .nav {\n    &-list {\n      &:first-child {\n        .nav-item:first-child {\n          border-top: none;\n        }\n      }\n    }\n    &-item {\n      border: none;\n      padding: .25em 0;\n      &-a {\n        padding-right: 1em;\n        line-height: 2;\n        & .fa {\n          display: none;\n        }\n      }\n    }\n    &-sub {\n      &-item {\n        display: block;\n        padding: .25em 0;\n        &-a {\n          padding-right: 1em;\n          line-height: 2;\n        }\n      }\n    }\n  }\n  &-info {\n    padding: 2em;\n  }\n  &-copyright {\n    &-p {\n      text-align: right;\n    }\n  }\n}\n\n// .items-1-per-col {max-height: 3em}\n// .items-2-per-col {max-height: 6em}\n// .items-3-per-col {max-height: 9em}\n// .items-4-per-col {max-height: 12em}\n// .items-5-per-col {max-height: 15em}\n// .items-6-per-col {max-height: 18em}\n// .items-7-per-col {max-height: 21em}\n// .items-8-per-col {max-height: 24em}\n// .items-9-per-col {max-height: 27em}\n// .items-10-per-col {max-height: 30em}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1227);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("16e4d8f0", content, true, {});

/***/ })

});


// WEBPACK FOOTER //
// static/js/62.91f0e2dd6cf5a349602e.js